export const isAlert = (information: string) => {
  return alert(information)
}
